import { SubContractor } from 'src/app/modules/sub-contractor';
import { BaseModel } from './base-model';
import { Project } from './project';
import { EquipmentType } from './equipment-type';

export class Equipment extends BaseModel {

  // for CASL subject detection on code minification
  static get modelName() { return 'Equipment'; }

  /* tslint:disable */
  number: string;
  make: string;
  model: string;
  description: string;
  equipment_type: EquipmentType;
  equipment_type_id: string;
  sub_contractor: SubContractor;
  sub_contractor_id: string;
  project: Project;
  project_id: string;
  /* tslint:enable */

  get relations() {
    return {
      equipment_type: EquipmentType,
      sub_contractor: SubContractor,
      project: Project,
    };
  }

  /**
   * Processes json obj and sets respective properties.
   * @param jsonObj json from api
   */
  parseJSONData(jsonObj: any) {
    super.parseJSONData(jsonObj);
    this.project_id = this.project?.id || this.project_id;
    this.sub_contractor_id = this.sub_contractor?.id || this.sub_contractor_id;
    this.equipment_type_id = this.equipment_type?.id || this.equipment_type_id;
  }

  /**
   * Converts this model to POST payload json object
   * @return {object}
   */
  toPayload() {
    return {
      number: this.number,
      make: this.make,
      model: this.model,
      description: this.description,
      equipment_type_id: this.equipment_type?.id || this.equipment_type_id,
      sub_contractor_id: this.sub_contractor?.id || this.sub_contractor_id,
    };
  }
}
